<script setup lang="ts">
import { storeToRefs } from 'pinia';
import BaseButton from '@/common/components/molecules/baseButton/BaseButton.vue';
import { useInternational } from '@/common/locale';
import { useChatStore } from '@/ai/store/chat';
import { useAiAssistantVisible } from '@/ai/composables/useAiAssistantVisible';

const { t } = useInternational();

const chatStore = useChatStore();
const { isChatWindowOpen } = storeToRefs(chatStore);

const isEnabled = useAiAssistantVisible();

const onClickButton = () => {
  chatStore.toggleChat();
};
</script>

<template>
  <li
    v-if="isEnabled"
    :class="['menu-element', 'chatbot-menu', { selected: isChatWindowOpen }]"
  >
    <base-button
      tag="button"
      type="button"
      class="menu-element__title chatbot-menu__title"
      @click="onClickButton"
    >
      <div class="menu-element__title-inner chatbot-menu__title-inner">
        <div class="menu-element__item-icon">
          <ev-icon
            size="medium"
            icon="ev-icon-spark"
          />
        </div>
        <h3>{{ t('WORD.GNB.CHATBOT') }}</h3>
      </div>
    </base-button>
  </li>
</template>

<style scoped lang="scss">
.chatbot-menu {
  .base-menu.expanded & {
    width: 100%;
  }

  &__title {
    .base-menu.expanded & {
      width: 100%;
      padding: 8px;
    }
  }

  &__title-inner {
    height: 100%;
    padding-left: 0;

    :deep(.menu-element__item-icon) {
      background-color: transparent !important;
    }

    :deep(.menu-element__item-icon i) {
      font-size: var(--gnb-menu-icon-size);
      color: var(--gnb-menu-icon-color) !important;
    }
  }

  &.selected {
    .menu-element__title {
      background-color: rgb(var(--color-gray-00-00-rgb), 0.12);
    }
  }
}
</style>
